import * as React from "react";
import { useQuery } from "@apollo/client";
import gql from "graphql-tag";

// Styles
import "./Footer.scss";

// Misc.
import { GET_FOOTER_DATA } from "../../queries/Footer.queries";
import IconSocial from "../../icons/IconSocial";

const QUERY_FOOTER = gql`
  ${GET_FOOTER_DATA}
`;

const Footer: React.FC = () => {
  const [copyright, setCopyright] = React.useState("");
  const [soMe, setSoMe] = React.useState([]);
  const [links, setLinks] = React.useState([]);

  const handleComplete = (data: any) => {
    setCopyright(data.footer.copyright);
    setSoMe(data.footer.social);
    setLinks(data.footer.links);
  };

  const { loading } = useQuery(QUERY_FOOTER, {
    onCompleted: handleComplete,
  });

  return (
    <footer className="footer">
      {!loading && (
        <div className="footer__inner">
          <div className="footer__content">
            <p className="footer__legal">{copyright}</p>
          </div>
          <div className="footer__content">
            <div className="footer__content__left">
              {links &&
                links.map((linkItem: any, index) => (
                  <a
                    key={`links-${index}`}
                    href={linkItem.url}
                    target={linkItem.target}
                  >
                    {linkItem.title}
                  </a>
                ))}
            </div>
            <div className="footer__content__right">
              {soMe &&
                soMe.map((socialItem: any, index) => (
                  <a
                    key={`some-${index}`}
                    href={socialItem.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <IconSocial type={socialItem.icon} />
                  </a>
                ))}
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
